import { useMutation, useQuery, useQueryClient } from "react-query";
import { client } from "../client";
import { Command, CommandStatus } from "../types/command.types";

export const createCommand = async ({ ...command }: Partial<Command>) => {
	const response = await client.post<Command>(`/commands/`, {
		...command,
	});
	return response.data;
};

export const updateCommand = async ({
	id,
	log,
	...command
}: Partial<Command> & { log?: boolean }) => {
	const response = await client.patch<Command>(
		`/commands/${id}?log=${log === true ? "t" : "f"}`,
		{
			...command,
		},
	);
	return response.data;
};

export const deleteCommand = async ({ id }: Partial<Command>) => {
	const response = await client.delete<Command>(`/commands/${id}`);
	return response.data;
};

export const changeCommandStatus = async ({
	id,
	status,
	reason,
	explanation,
}: {
	id: number;
	status: string;
	reason?: string;
	explanation?: string;
}) => {
	const response = await client.post<object>(`/commands/status/${id}`, {
		status,
		reason,
		explanation,
	});
	return response.data;
};

export const bulkChangeCommandStatus = async ({
	ids,
	status,
	managerId,
}: {
	ids: number[];
	status: string;
	managerId?: number;
}) => {
	const response = await client.post<object>(`/commands/status/bulk`, {
		ids,
		status,
		manager: managerId,
	});
	return response.data;
};

export const useBulkChangeCommandStatus = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: bulkChangeCommandStatus,
		onSuccess: () => {
			queryClient.invalidateQueries(["commands-paginated"]);
		},
	});
};

export const createNewExport = async () => {
	const response = await client.post<object>(`/commands/exports/generate`, {});
	return response.data;
};

export const retrieveExport = async (id: number) => {
	const response = await client.get<{ content: string }>(
		`/commands/exports/${id}/download`,
	);
	return response.data;
};

export const getCommandOrderFilesId = async (ids: number[]) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const response = await client.get<
		{ id: number; purchaseOrderFileId: number; exposedId: string }[]
	>(`commands/orderFilesId`, {
		params: { ids },
	});
	return response.data;
};

export const useGetCommandOrderFilesId = ({ ids }: { ids: number[] }) => {
	return useQuery({
		queryKey: ["getCommandOrderFilesId"],
		queryFn: () => getCommandOrderFilesId(ids),
		enabled: false,
	});
};

export const validateCommand = async ({ id, ...command }: Partial<Command>) => {
	const response = await client.patch<Command>(`/commands/${id}`, {
		...command,
		status: CommandStatus.WAITING_FOR_RECEPTION,
	});
	return response.data;
};
